var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog-reservaqui',{attrs:{"visivel":_vm.visivel,"tipo":"confirma","mensagem":_vm.mensagem,"corpoMensagem":_vm.corpoMensagem},on:{"close":function($event){return _vm.$emit('close')},"confirma":function($event){return _vm.$emit('confirma')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }